module.exports = __webpack_public_path__ + "2106beb3324828f7214c781c79f49186.fbx";